
import { useNavigate } from "react-router-dom";
import { Pagination,  Stack,  TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { LayoutTabla } from "../../layouts";
import { useCarritoItemsStore, useModalStore } from "../../../stores";
import { useValidarRoles } from "../../../hooks";
import { fechaSinHora } from "../../../helpers/prepararFecha";

const paginado = Number(process.env.REACT_APP_PAGINADO);




export const TablaItemsProduccion = ({ data, chagePage=() => {}, page=0 }) => {


    const navigate = useNavigate();
    const { isAdminRol } = useValidarRoles();
    const { modalFormToggle } = useModalStore();
    const { totalItems=50, setActivarItem } = useCarritoItemsStore();


    const handleEntregarItem = async(id) => {
        modalFormToggle(true);
        setActivarItem(id);
    }


    return (
        <>
        {(data?.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalItems / +paginado)} disabled={Math.ceil(totalItems / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead >
                    <TableRow>
                        <TableCell sx={{width:'10%'}}>O.P.</TableCell>
                        <TableCell sx={{width:'15%'}}>Entrega</TableCell>
                        <TableCell sx={{width:'25%'}}>Producto</TableCell>
                        <TableCell sx={{width:'24%'}}>Cliente</TableCell>
                        <TableCell sx={{width:'13%'}}>Estado</TableCell>
                        <TableCell sx={{width:'13%'}}>Opciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map( item => (
                        <TableRow key={ item.id }>
                            <TableCell>{ item.op?.op }</TableCell>
                            <TableCell>
                                {item.op?.fechaEntrega 
                                ?   fechaSinHora(item.op.fechaEntrega)
                                :   <span style={{ color:'red' }}>No-Dato</span>
                                }
                            </TableCell>
                            <TableCell>{ item.producto?.nombre }</TableCell>
                            <TableCell>{ item.op?.quienCompra?.nombre }</TableCell>
                            <TableCell>{ item.area }</TableCell>
                            <TableCell>
                                <Stack direction="row" spacing={1} justifyContent="center">
                                    <TooltipAndIcon
                                        titulo="Detalles Items"
                                        icono="ver"
                                        color="white"
                                        onClick={() => navigate(`/super/dt-pro-op/${item.id}`)}
                                    />  
                                    {(isAdminRol()) &&
                                    <>
                                    <TooltipAndIcon
                                        titulo="Editar Estados"
                                        icono="editar"
                                        color="white"
                                        onClick={() => handleEntregarItem(item.id) }
                                    /> 

                                    <TooltipAndIcon
                                        titulo="Ver Trasabilidad"
                                        icono="trasabilidad"
                                        color="white"
                                        onClick={() => navigate(`/super/registro/${ item.id }/items`)}
                                    /> 
                                    </>
                                    
                                    }
                                </Stack>
                            </TableCell>
                        </TableRow>
                    ))
                    }
                </TableBody>
            </LayoutTabla>

        :   <MensajeAlertaDanger titulo='No hay items de producción disponibles' />
        }
        </>

    )
}
